// Chakra imports
import { Box, VStack, Button, Text } from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card.js";
import KycInfo from "views/user/profile/components/KycInfo";
import React from "react";
import Pattern from "assets/images/pattern1.png";

export default function VirtualCardInfo(props) {
  const { user, getUser, createVirtualCard, cardLoading } = props;

  return (
    <>
      {user.kycStatus !== "completed" ? (
        <KycInfo user={user} getUser={getUser} />
      ) : (
        <GetVirtualCard
          user={user}
          createVirtualCard={createVirtualCard}
          cardLoading={cardLoading}
        />
      )}
    </>
  );
}

const GetVirtualCard = (props) => {
  const { user, createVirtualCard, cardLoading } = props;
  return (
    <Card
      shadow="md"
      background="blue.500"
      backgroundImage={`url(${Pattern})`}
      backgroundPosition="center center"
      backgroundSize="cover"
      backgroundRepeat="no-repeat"
    >
      <VStack>
        <Box textAlign="start">
          <Text
            color="white"
            fontSize={{ base: "xs", sm: "sm", md: "md", lg: "lg" }}
            my={{ base: "auto", "2xl": "10px" }}
            textAlign="start"
          >
            Hi
          </Text>
          <Text
            color="white"
            fontWeight="bold"
            fontSize={{ base: "md", sm: "md", md: "lg", lg: "xl" }}
            my={{ base: "auto", "2xl": "10px" }}
            textAlign="start"
          >
            {user.firstName} {user.lastName}
          </Text>
          <Text
            as="h3"
            color="white"
            textAlign="start"
            fontSize={{ base: "sm", sm: "md", md: "md", lg: "lg" }}
            mt={{ base: "5px", "2xl": "5px" }}
          >
            You are set to get your{" "}
            <Text as="span" color="orange.600">
              Virtual Card
            </Text>{" "}
            issued, please click on the Proceed button below to continue
          </Text>
        </Box>
        <Box width="100%">
          <Button
            mt="5"
            colorScheme="white"
            background="#fff"
            color="#000"
            variant="solid"
            fontSize={{ base: "xs", sm: "sm", md: "sm", lg: "md" }}
            isLoading={cardLoading}
            loadingText={"Wait.."}
            onClick={createVirtualCard}
          >
            Proceed
          </Button>
        </Box>
      </VStack>
    </Card>
  );
};
